import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import { PageLoader } from "../../components/page-loader";
import { appUrls } from "../../utils/use-get-page-url";

export const LoginPage: React.FC = () => {
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (isLoading) {
      return;
    }
    if (isAuthenticated) {
      navigate(appUrls.home, { replace: true });
      return;
    }
    loginWithRedirect();
  }, [isLoading, isAuthenticated, loginWithRedirect, navigate]);

  return (
    <div>
      <PageLoader />
      Redirecting to Login
    </div>
  );
};
